import type React from "react"
import { Box, styled, useTheme } from "@mui/material"

interface CircularButtonProps {
    size?: number;
    onClick: () => void;
}

const getResponsiveSize = (small: number, large: number): number => {
    const screenSize = Math.sqrt(window.innerWidth ** 2 + window.innerHeight ** 2) / 100
    return small + (large - small) * Math.min(Math.max((screenSize - 4) / 4, 0), 1)
}

const IconContainer = styled(Box)<{ size: number }>(({ size }) => ({
    position: "relative",
    width: size,
    height: size,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}))

const GradientCircle = styled(Box)<{ size: number; colors: string[] }>(({ size, colors }) => ({
    position: "absolute",
    width: size,
    height: size,
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`,
}))

const WhiteCircle = styled(Box)<{ size: number }>(({ size, theme }) => ({
    position: "absolute",
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
}))

const IconLayer = styled(Box)({
    position: "relative",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
})

const CameraButtonContainer: React.FC<CircularButtonProps> = ({ size = 90, onClick }) => {
    const theme = useTheme();
    const buttonSize = size * getResponsiveSize(0.5, 2.5)
    const gradientSize = buttonSize * getResponsiveSize(0.25, 0.9)
    const normalSize = buttonSize * getResponsiveSize(0.12, 0.7)

    return (
        <IconContainer size={buttonSize} onClick={onClick}>
            <GradientCircle size={gradientSize} colors={[theme.palette.primary.light, theme.palette.primary.light]} sx={{ opacity: 0.5 }} />
            <GradientCircle size={gradientSize * 0.9} colors={[theme.palette.primary.light, theme.palette.primary.light]} sx={{ opacity: 0.7 }} />
            <WhiteCircle size={normalSize} />
            <IconLayer>
                <img
                    src="/images/Camera.svg"
                    alt="Camera Icon"
                    style={{ width: size, height: size, objectFit: "contain" }}
                />
            </IconLayer>
        </IconContainer>
    )
}

export default CameraButtonContainer

